// AI Generated Component
import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';

interface SeoCategory {
    title: string;
    color: string;
    errors: number;
    inCompliance: number;
    colors: string[];
    data: number[];
    options: any;
}

@Component({
    selector: 'seo-summary-opportunities-in-category',
    templateUrl: './opportunities-in-category.component.html',
    standalone: false,
})
export class SeoSummaryOpportunitiesInCategoryComponent implements OnInit {
    @Input() alertPageCount!: number;
    @Input() warningPageCount!: number;
    @Input() infoPageCount!: number;
    @Input() technicalPageCount!: number;
    @Input() pageCount!: number;

    seoCategories: SeoCategory[] = [];
    labels: string[] = ['', ''];

    constructor (private translateService: TranslateService) {}

    ngOnInit (): void {
        this.activate();
    }

    activate (): void {
        this.seoCategories = [];
        this.labels = ['', ''];
        this.setupSeoDoughnuts();
    }

    setupSeoDoughnuts (): void {
        const charts = [
            {
                title: this.translateService.getString('High priority'),
                pageErrors: this.alertPageCount,
                circleColor: 'text-danger',
            },
            {
                title: this.translateService.getString('Medium priority'),
                pageErrors: this.warningPageCount,
                circleColor: 'text-warning',
            },
            {
                title: this.translateService.getString('Low priority'),
                pageErrors: this.infoPageCount,
                circleColor: 'text-info',
            },
            {
                title: this.translateService.getString('Technical SEO Issues'),
                pageErrors: this.technicalPageCount,
                circleColor: 'text-primary',
            },
        ];

        for (let i = 0; i < charts.length; i++) {
            this.seoCategories.push(this.setupDoughnut(charts[i]));
        }
    }

    setupDoughnut (detail: any): SeoCategory {
        const colors = ['#4dc0bd', '#DCDCDC'];

        return {
            title: detail.title,
            color: detail.circleColor,
            errors: detail.pageErrors,
            inCompliance: this.pageCount - detail.pageErrors,
            colors: colors,
            data: [this.pageCount - detail.pageErrors, detail.pageErrors],
            options: this.getOptions(detail.pageErrors, this.pageCount),
        };
    }

    getOptions (errorCount: number, pagesCount: number): any {
        return {
            centerText: {
                percentageLabel: this.formatPercentage(1 - errorCount / pagesCount),
            },
            cutoutPercentage: 80,
            tooltips: {
                callbacks: {
                    label: (tooltipItem: any, data: any) => {
                        return this.formatNumber(data.datasets[0].data[tooltipItem.index]);
                    },
                },
            },
        };
    }

    private formatPercentage (value: number): string {
        return (value * 100).toFixed(2) + '%';
    }

    private formatNumber (value: number): string {
        return value.toLocaleString();
    }

    trackByIndex (index: number, item: any): number {
        return index;
    }
}
